import { render } from "./ValidateAddress.vue?vue&type=template&id=2bd3f6ff&ts=true"
import script from "./ValidateAddress.ts?vue&type=script&lang=ts&external"
export * from "./ValidateAddress.ts?vue&type=script&lang=ts&external"

import "./ValidateAddress.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__